// funkcinalita pro práci s URL adresami

export function getServerUrl() {
  if (window.location.hostname === "localhost" ) {
    return "http://localhost:44350";
  } else if (window.location.hostname === "test.capoeira.sk") {
    return "https://testapi.capoeira.sk";
  } else if (window.location.hostname === "capoeira.sk") {
    return "https://api.capoeira.sk";
  } else {
    return "";
  }
}

export const API_BASE_URL = getServerUrl() + "/api";

export const LOGIN_URL = getServerUrl() + "/api/login";

export const REGISTER_URL = getServerUrl() + "/api/register";

export const FORGOT_PASSWORD_URL = getServerUrl() + "/api/forgot-password";

export const IS_AUTHENTICATED_URL = getServerUrl() + "/api/is-authenticated";

export const ERROR_LOG_URL = getServerUrl() + "/api/errorlog";

export const VERIFY_EMAIL_URL = getServerUrl() + "/api/verify-email";

export const RESEND_VERIFICATION_URL =
  getServerUrl() + "/api/resend-verification";

export const FRONTEND_ERROR_LOG_URL = getServerUrl() + "/api/frontend-errorlog";

export const GET_USERS_URL = getServerUrl() + "/api/users";

export const VERIFY_USER_URL = getServerUrl() + "/api/user/verify";

export const SUBSCRIPTIONS_PLANS_URL =
  getServerUrl() + "/api/subscriptions-plans";

export const DELETES_USER_URL = (id) => getServerUrl() + `/api/users/${id}`;

export const UPDATE_USER_URL = getServerUrl() + "/api/updateUser";

// subscriptions
export const SUBSCRIBE_URL = getServerUrl() + "/api/subscriptions";
export const USER_SUBSCRIBE_URL = getServerUrl() + "/api/subscriptions/user";
export const SUBSCRIPTION_PAYMENTS_URL =
  getServerUrl() + "/api/subscriptions/payments";
export const CREATE_SUBSCRIPTION_INTENT_URL =
  getServerUrl() + "/api/create-payment-intent";
export const CANCEL_PAYMENT_INTENT_URL =
  getServerUrl() + "/api/cancel-payment-intent";
export const CREATE_PAYMENT_INTENT_SUBSCRIPTION_URL =
  getServerUrl() + "/api/create-subscription-intent";
export const REFUND_SUBSCRIPTION_URL = getServerUrl() + "/api/refund";
export const REFUND_MANUAL_SUBSCRIPTION_URL =
  getServerUrl() + "/api/refund-manual";
export const REQUEST_REFUND_URL = getServerUrl() + "/api/request-refund";
export const MANUAL_ADD_SUBSCRIPTION_URL =
  getServerUrl() + "/api/subscriptions/manual-add";
export const UPDATE_SUBSCRIPTION_DATES_URL =
  getServerUrl() + "/api/subscriptions/update-dates";
///create-zero-subscription
export const CREATE_ZERO_SUBSCRIPTION_URL =
  getServerUrl() + "/api/create-zero-subscription";
export const VERIFY_PAYMENT_URL = getServerUrl() + "/api/verify-payment";
export const BLOCKED_PAYMENTS_URL = getServerUrl() + "/api/blocked-payments";

// subscriptions_plans
export const SUBSCRIPTION_PLANS_URL =
  getServerUrl() + "/api/subscriptions-plans";
export const PUBLIC_SUBSCRIPTION_PLAN_URL =
  getServerUrl() + "/api/subscriptions-plans_public";
export const SUBSCRIPTION_PLAN_CENNIK_URL =
  getServerUrl() + `/api/subscriptions-plans/cennik/`;

// trainings
export const TRAININGS_URL = getServerUrl() + "/api/events";
export const TRAININGS_PERIOD_URL = getServerUrl() + "/api/events/period";
// profile
export const PROFILE_URL = getServerUrl() + "/api/profile";
export const CHANGE_PASSWORD_URL = getServerUrl() + "/api/change-password";

// contact form
export const CONTACT_URL = getServerUrl() + "/api/send-contact-email";

// bulk email (admin)
export const ACTIVE_SUBSCRIBER_EMAILS_URL = getServerUrl() + "/api/active-subscriber-emails";
export const SEND_BULK_EMAIL_URL = getServerUrl() + "/api/send-bulk-email";
